<template>
  <div class="login">
    <div class="login-container">
      <img class="login-logo" src="../assets/img/login/logo.svg" alt="MCK" />
      <form class="login-form" @submit.prevent="login">
        <div class="login-input">
          <span class="mck">B</span>
          <input
            v-model="user.username"
            type="text"
            placeholder="Потребителско име"
            autocomplete="off"
          />
        </div>
        <div class="login-input">
          <span class="mck">A</span>
          <input v-model="user.password" type="password" placeholder="Парола" />
        </div>
        <button class="login-submit" type="submit">Вход</button>
        <div v-if="error" class="login-error" :class="{ 'login-error-active': error }">
          <p>{{error}}</p>
        </div>
        <a class="cdots" href="https://cdots.bg/" target="_blank">2020 &copy; SOLUTION DELIVERED BY CDOTS</a>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      error: ''
    };
  },
  methods: {
    login() {
      const username = this.user.username.toLowerCase();
      const password = this.user.password;
      if (username.length && password.length) {
        this.$store
          .dispatch('login', { username, password })
          .then(() =>
            this.$router.push(
              this.$route.query.from ? this.$route.query.from : '/'
            )
          )
          .catch(err => {
            this.error = err.response.data.failed;
          });
      } else {
        this.error = 'Моля въведете потребителско име и парола!';
      }
    }
  }
};
</script>

<style scoped>
.login {
  background-image: url('../assets/img/login/login_bg.jpg');
  background-position: left;
  background-size: cover;
  height: 100vh;
  width: 100%;
}
.login-container {
  align-items: center;
  background-image: url('../assets/img/login/login_container.jpg');
  background-position: left;
  background-size: cover;
  border-left: 10px solid #E65100;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100vh;
  position: relative;
  width: 400px;
}
.login-logo {
  height: auto;
  width: 200px;
}
.login-form {
  display: flex;
  flex-direction: column;
  width: 300px;
}
.login-error {
  align-items: center;
  background-color: #f2dede;
  border-radius: 4px;
  display: flex;
  height: 50px;
  justify-content: center;
  padding: 5px 15px;
  opacity: 0;
}
.login-error p {
  color: #a94442;
  text-align: center;
}
.login-error-active {
  opacity: 1;
}
.login-input {
  align-items: center;
  display: flex;
  margin-bottom: 15px;
  position: relative;
}
.login-input .mck {
  color: #fff;
  font-size: 20px;
  margin-right: 10px;
}
.login-input input {
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 14px;
}
.login-input input::placeholder {
  color: #fff;
}
.login-input input:-moz-placeholder {
  color: #fff;
}
.login-input input::-moz-placeholder {
  color: #fff;
}
.login-input input:-ms-input-placeholder {
  color: #fff;
}
.login-input input::-webkit-input-placeholder {
  color: #fff;
}
.login-submit {
  background-color: #9c9c9c;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  height: 35px;
  margin: 10px 0;
  padding: 5px 15px;
  text-transform: uppercase;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.login-submit:hover {
  background-color: #b8b8b8;
}
.cdots {
  bottom: 20px;
  color: #989898;
  display: block;
  font-size: 10px;
  left: 50%;
  margin-top: 15px;
  position: absolute;
  text-align: center;
  text-decoration: none;
  transform: translateX(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.cdots:hover {
  color: #b8b8b8;
}

@media screen and (max-width: 1000px) {
  .login-container {
    border-left: 0px;
    border-top: 10px solid #E65100;
  }
}
@media screen and (max-width: 600px) {
  .login-container {
    width: 100%;
  }
}
@media screen and (max-width: 400px) {
  .login-form {
    width: 280px;
  }
}
</style>
